import { ICopyable } from '../controls/common/icopyable';
import { IFolderState } from './interfaces/folder-state.interface';
import { ISortable } from './interfaces/sortable.interface';

export class FolderState implements ICopyable<IFolderState>, ISortable {
    id: number = null;
    name: string = null;
    order: number = null;

    public createCopy(): FolderState {
        const instance = new FolderState();
        instance.id = this.id;
        instance.name = this.name;
        instance.order = this.order;

        return instance;
    }

    public static createFormCopy(folderState: FolderState): IFolderState {
        const instance = new FolderState();
        instance.id = folderState.id;
        instance.name = folderState.name;
        instance.order = folderState.order;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.order = other.order;
    }

    /**
     * Retourne une instance de FolderSatte à partir d'une instance de IFolderState.
     * @param other : Instance de IFolderState.
     * @returns : Instance de FolderState.
     */
    public static from(other: IFolderState) {
        if (!!other) {
            const instance = new FolderState();

            instance.id = other.id;
            instance.name = other.name;
            instance.order = other.order;

            return instance;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }
}
